import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import AddDaysForm from "./AddDaysForm";
import { AddDaysFormValues } from "src/models/AddDays.model";
import { useAddPlanMutation } from "src/services/CourseServices";
import { showToast } from "src/utils/showToaster";
import { useParams } from "react-router-dom";

type Props = {
  onClose: () => void;
};

const AddDaysFormWrapper = ({ onClose }: Props) => {

     const {courseId} = useParams()
  const [addPlan] = useAddPlanMutation();

  // Form Initial Values
  const initialValues: AddDaysFormValues = {
    day: "",
    planName: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    day: string().required("Please enter day"),
    planName: string().required("Please enter planName"),
  });

  // Handle Submit
  const handleSubmit = (
    values: AddDaysFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AddDaysFormValues>
  ) => {
    const formattedValues = {
      planName: values?.planName,
      noOfDays: values?.day,
      courseId : courseId
    };

    addPlan(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AddDaysForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddDaysFormWrapper;
